import actions from './actions'
import getters from './getters'
import * as types from './mutation_types'

const state = {
  specificQueryParams: {},
  isExpressDeliverySelected: true, // TODO: Remove it after AB test. Temporary solution
}

const mutations = {
  [types.SET_SPECIFIC_QUERY_PARAMS_FULLY] (state, queryParams) {
    state.specificQueryParams = queryParams
  },
  [types.SET_SPECIFIC_QUERY_PARAM] (state, queryParams) {
    state.specificQueryParams = {
      ...state.specificQueryParams,
      ...queryParams,
    }
  },
  [types.SET_EXPRESS_DELIVERY_SELECTED_STATE] (state, value) {
    state.isExpressDeliverySelected = value
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
